import * as React from 'react';
import PropTypes from 'prop-types';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function ProgressBar(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <div>
        <CircularProgress
          variant="determinate"
          sx={{
            color: props.bgColor,
          }}
          size={props.size ?? 120}
          thickness={props.thickness}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          disableShrink
          sx={{
            color: props.color,
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
          }}
          size={props.size ?? 120}
          thickness={props.thickness}
          value={props.value}
        />
      </div>
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          style={{
            color: props.labelColor,
            fontWeight: 500,
            fontSize: props.fontSize ?? '18px',
            lineHeight: '20px',
            marginBottom: '4px',
          }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default ProgressBar;

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  thickness: PropTypes.number,
  labelColor: PropTypes.string,
  size: PropTypes.number,
};
